export default __webpack_public_path__ + "static/media/icon-config-filled.fa069660.svg";